export default {
	'no-items-to-show': 'لا توجد مواد في الخطة لهذه الفترة',
	'unnamed-plan': 'خطة بدون اسم',
	'material-name': 'اسم المادة',
	'form-type': 'نوع النموذج',
	quantity: 'الكمية',
	classification: 'التصنيف',
	search: 'بحث',
	reset: 'إعادة تعيين',
	'from-date': 'من',
	'to-date': 'إلى',
}
